var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (icon) { 
__p+='\n<i data-icon="'+
((__t=( icon ))==null?'':__t)+
'"></i> &nbsp;\n';
 } 
__p+='\n  ';
 if (statusIcon) { 
__p+='\n<i data-status-icon="'+
((__t=( statusIcon ))==null?'':__t)+
'"></i> &nbsp;\n';
 } 
__p+='\n    ';
 if (text) { 
__p+='\n'+
((__t=( text ))==null?'':__t)+
'\n';
 } 
__p+='\n';
}
return __p;
};
